var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-radio-group',{attrs:{"options":_vm.options,"text-field":"name","value":_vm.myValue,"checked":_vm.value,"disabled":_vm.disabled},on:{"change":_vm.updateValue,"input":_vm.inputValue}})}
var staticRenderFns = []

export { render, staticRenderFns }